import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import moment from 'moment';
import {PlacementTestsHeader} from './PlacementTestsHeader';
import {PlacementTest} from '../../../../graphql/API';
import {PlacementTestReport} from './PlacementTestReport';

export const PlacementTests = () => {
  const selectedStudent = useSelector(
    (state: any) => state.student.selectedStudent,
  );

  const [placementTests, setPlacementTests] = useState<any>();
  const [selectedPlacementTest, setSelectedPlacementTest] = useState<any>();

  useEffect(() => {
    let tests = selectedStudent?.placementTests?.sort(
      //@ts-ignore
      (a: any, b: any) => new Date(b.createdAt) - new Date(a.createdAt),
    );
    setPlacementTests(tests);
  }, [selectedStudent]);

  return (
    <div>
      <PlacementTestsHeader
        onChange={(selectedTestId) => {
          const selectedTest = placementTests.find(
            (pTest: PlacementTest) => pTest.id === selectedTestId,
          );
          selectedTest && setSelectedPlacementTest(selectedTest);
        }}
        items={placementTests?.map((pTest: PlacementTest) => {
          return {
            key: pTest.id,
            label: `Test on ${moment(pTest.createdAt).format('YYYY-MM-DD')}`,
            children: <PlacementTestReport placementTest={pTest} />,
          };
        })}
      />
    </div>
  );
};
